import { createSelector } from '@ngrx/store';
import { getManagementState, ManagementState } from '../management.reducer';
import { NutritionState } from './nutrition.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';

const getState = createSelector(getManagementState, (state: ManagementState) => state.nutrition);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getAssignment = createSelector(getState, (state: NutritionState) => state.assignment);
const getAssignments = createSelector(getState, (state: NutritionState) => state.assignments);
const getCenterLoading = createSelector(getState, (state: NutritionState) => state.centerLoading);
const getDate = createSelector(getState, (state: NutritionState) => state.date);
const getLocation = createSelector(getState, (state: NutritionState) => state.location);
const getLocationSetType = createSelector(getState, (state: NutritionState) => state.locationSetType);
const getRightLoading = createSelector(getState, (state: NutritionState) => state.rightLoading);
const getProfileOptions = createSelector(getState, (state: NutritionState) => state.profileOptions);

export const NutritionSelectors = {
    ...asyncActionStateSelectors,
    getAssignment,
    getAssignments,
    getCenterLoading,
    getDate,
    getLocation,
    getLocationSetType,
    getProfileOptions,
    getRightLoading
};
